export default __webpack_public_path__ + "static/media/7_Peace of mind.6667b2cf.jpg";